import React, {
    useEffect,
    useState,
} from "react";

import {
    Box,
    Flex,
    HStack,
    Spinner,
    Text,
    VStack,
    Avatar,
    Divider,
} from "@chakra-ui/react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import StatusBadge, {
    getStatusVariant,
} from "components/Badges/StatusBadge";

import ReusableDrawer from "components/Drawers/ReusableDrawer";

import ViewDriver from "views/Dashboard/DriverManagement/components/ViewDriver";

import AdminTopUpWalletDrawer from "views/Dashboard/DriverManagement/components/AdminTopUpWalletDrawer";

import {
    fetchReferredDriversAction,
} from "state/actions/referredDriverActions";

import {
    adminTopUpWalletAction,
    fetchDriverWalletsAction,
} from "state/actions/driverWalletActions";

import {
    useCustomNotification,
} from "components/Toasts/OpenNotification";


const ReferredDriversDrawer = ({
    isOpen,
    onClose,
    referralCode,
}) => {

    const dispatch = useDispatch();


    const {
        referredDrivers = [],
        loading,
    } = useSelector(
        (state) =>
            state.referredDrivers
    );



    const {
        wallets = [],
    } = useSelector(
        (state) =>
            state.drivers || {}
    );



    const [
        selectedDriver,
        setSelectedDriver,
    ] = useState(null);



    const [
        isViewDriverOpen,
        setViewDriverOpen,
    ] = useState(false);



    const [
        isTopUpOpen,
        setTopUpOpen,
    ] = useState(false);


    const showToast =
        useCustomNotification();



    const getProfileImage = (
        user
    ) => {

        const doc =
            user?.documents?.find(
                (d) =>
                    d.document_type ===
                    "Profile Image"
            );


        if (!doc) {
            return null;
        }


        const API_URL =
            process.env
                .REACT_APP_API_BASE_URL
                ?.replace(
                    /\/$/,
                    ""
                );


        if (!API_URL) {
            return null;
        }


        return `${API_URL}/${doc.file_path.replace(
            /^\//,
            ""
        )}`;
    };




    useEffect(() => {

        if (
            isOpen &&
            referralCode
        ) {

            dispatch(
                fetchReferredDriversAction(
                    referralCode
                )
            );


          
            dispatch(
                fetchDriverWalletsAction()
            );
        }

    }, [
        dispatch,
        isOpen,
        referralCode,
    ]);


    const walletLookup = {};


    if (
        Array.isArray(wallets)
    ) {

        wallets.forEach(
            (wallet) => {

                if (
                    wallet?.driver_id
                ) {

                    walletLookup[
                        wallet.driver_id
                    ] = wallet;

                }

            }
        );
    }



    const handleViewDriver = (
        driver
    ) => {

        const driverId =
            driver?.driver_id ||
            driver?.driver
                ?.driver_id;


        const wallet =
            walletLookup[
                driverId
            ];



        setSelectedDriver({
            driver,
            wallet,
        });


        setViewDriverOpen(
            true
        );
    };


    const handleCloseViewDriver =
        () => {

            setViewDriverOpen(
                false
            );

            setSelectedDriver(
                null
            );
        };



    const handleTopUp = (
        driver
    ) => {

        setSelectedDriver(
            driver
        );


        setViewDriverOpen(
            false
        );


        setTopUpOpen(
            true
        );
    };



    const handleCloseTopUp =
        () => {

            setTopUpOpen(
                false
            );
        };




    const handleTopUpWallet =
        async ({
            driver_id,
            amount,
        }) => {

            const response =
                await dispatch(
                    adminTopUpWalletAction(
                        driver_id,
                        amount
                    )
                );


            if (
                response?.success
            ) {

                showToast({
                    type: "success",
                    message:
                        "Wallet Topped Up",
                    description:
                        "Complimentary wallet top-up allocated successfully.",
                });


                setTopUpOpen(
                    false
                );

            } else {

                showToast({
                    type: "error",
                    message:
                        "Top-up Failed",
                    description:
                        response?.error ||
                        "Unable to top up wallet.",
                });

            }


            return response;
        };




    return (
        <>

         

            <ReusableDrawer

                isOpen={
                    isOpen
                }

                onClose={
                    onClose
                }

                size="md"

                headerContent={

                    <Text
                        fontSize="lg"
                        fontWeight="700"
                    >
                        Partner Recruited Drivers
                    </Text>

                }

                bodyContent={

                    loading ? (

                        <Flex
                            justify="center"
                            py={10}
                        >

                            <Spinner
                                size="lg"
                                color="#071D54"
                            />

                        </Flex>

                    ) : (

                        <VStack
                            align="stretch"
                            spacing={0}
                        >

                            {
                                referredDrivers.length ===
                                0 ? (

                                    <Text
                                        textAlign="center"
                                        py={10}
                                        color="gray.500"
                                    >
                                        No recruited
                                        drivers found.
                                    </Text>

                                ) : (

                                    referredDrivers.map(
                                        (
                                            driver
                                        ) => (

                                            <Box
                                                key={
                                                    driver.driver_id
                                                }

                                                cursor="pointer"

                                                _hover={{
                                                    bg:
                                                        "gray.50",
                                                }}

                                                transition="0.2s"

                                                onClick={() =>
                                                    handleViewDriver(
                                                        driver
                                                    )
                                                }
                                            >

                                                <HStack
                                                    py={4}
                                                    justify="space-between"
                                                >

                                                    <HStack
                                                        spacing={4}
                                                    >

                                                        <Avatar

                                                            name={
                                                                driver
                                                                    .user
                                                                    ?.username
                                                            }

                                                            src={
                                                                getProfileImage(
                                                                    driver.user
                                                                )
                                                            }

                                                             bg="#071D54"
    color="white"
                                                        />


                                                        <Box>

                                                            <Text
                                                                fontWeight="600"
                                                            >
                                                                {
                                                                    `${driver.user?.first_name || ""} ${
                                                                        driver.user?.last_name || ""
                                                                    }`.trim() ||
                                                                    driver
                                                                        .user
                                                                        ?.username
                                                                }
                                                            </Text>


                                                            <Text
                                                                fontSize="sm"
                                                                color="gray.500"
                                                            >
                                                                {
                                                                    driver
                                                                        .user
                                                                        ?.phone_number
                                                                }
                                                            </Text>

                                                        </Box>

                                                    </HStack>


                                                    <StatusBadge

                                                        label={
                                                            driver.status
                                                        }

                                                        variant={
                                                            getStatusVariant(
                                                                driver.status
                                                            )
                                                        }

                                                    />

                                                </HStack>


                                                <Divider />

                                            </Box>

                                        )
                                    )

                                )
                            }

                        </VStack>

                    )

                }

            />




            <ReusableDrawer

                isOpen={
                    isViewDriverOpen
                }

                onClose={
                    handleCloseViewDriver
                }

                headerContent={

                    <Text
                        fontSize="lg"
                        fontWeight="700"
                    >
                        Driver
                    </Text>

                }

                bodyContent={

                    selectedDriver && (

                        <ViewDriver

                            driver={
                                selectedDriver
                            }

                            onClose={
                                handleCloseViewDriver
                            }

                            onTopUp={
                                handleTopUp
                            }

                        />

                    )

                }

            />


      

            <AdminTopUpWalletDrawer

                isOpen={
                    isTopUpOpen
                }

                onClose={
                    handleCloseTopUp
                }

                driver={
                    selectedDriver
                }

                onTopUp={
                    handleTopUpWallet
                }

            />

        </>
    );
};


export default ReferredDriversDrawer;